import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-173d6bd2"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "duration"
};
import { ref, onMounted, onUnmounted } from "vue";
import BenzAMRRecorder from "benz-amr-recorder";
export default /*#__PURE__*/_defineComponent({
  __name: 'voice',
  props: {
    amrUrl: {},
    duration: {},
    uniqueKey: {}
  },
  setup(__props) {
    const props = __props;
    const actived = ref(false);
    let playRec = null;
    const play = () => {
      if (props.amrUrl) {
        if (playRec) {
          if (playRec.isPlaying()) {
            stop();
            return;
          }
        }
        actived.value = true; // 开始播放时激活动画
        playRec = new BenzAMRRecorder();
        playRec.initWithUrl(props.amrUrl).then(() => {
          playRec.play();
          // 设置定时器，在播放结束后停止动画
          setTimeout(() => {
            actived.value = false; // 停止动画
          }, props.duration * 1000); // 将秒数转换为毫秒
        }).catch(() => {
          console.error("Playback failed or file is corrupted");
          actived.value = false; // 播放失败时停止动画
        });
      }
    };

    const stop = () => {
      if (playRec && playRec.isPlaying()) {
        playRec.stop();
        actived.value = false; // 停止动画
      }
    };

    onUnmounted(() => {
      actived.value = false; // 组件卸载时停止动画
    });

    onMounted(() => {
      document.addEventListener("click", stop);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: "voice-box",
        onClick: _withModifiers(play, ["stop"])
      }, [_createElementVNode("view", {
        class: _normalizeClass(["voice-bg", {
          'voice-play': actived.value
        }])
      }, null, 2), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.duration) + " \"", 1)], 8, _hoisted_1)]);
    };
  }
});